import React from "react";
import { MockedProvider } from "@apollo/client/testing";
import CreateMissionWorker from "../../../screens/create-mission/CreateMissionWorker";
import { buildMissionCount, buildWorkerInfo, getAvatarUrl, getAvatarUrl2 } from "../../factories";

import { GET_CLIENT_AND_INVITATION_WORKERS } from "../../../graphql/client";
import type { Meta, StoryObj } from "@storybook/react";
import { WorkingPermitStatus } from "../../../__generated__/graphql";

const StoryComponent = () => {
    const worker = buildWorkerInfo({
        missionCount: buildMissionCount({
            accepted: 3,
        }),
    });

    const mocks = [
        {
            request: {
                query: GET_CLIENT_AND_INVITATION_WORKERS,
            },
            newData: () => ({
                data: {
                    getClientWorkers: [
                        worker,
                        buildWorkerInfo({
                            name: "Major Kusanagi",
                            avatarUrl: getAvatarUrl(),
                            workPermitStatus: WorkingPermitStatus.None,
                        }),
                        buildWorkerInfo({
                            name: "Naruto Uzumaki",
                            avatarUrl: getAvatarUrl2(),
                            workPermitStatus: WorkingPermitStatus.InProcess,
                        }),
                    ],
                    allInvitations: { count: 0, elements: [] },
                },
            }),
        },
    ];

    return (
        <MockedProvider mocks={mocks}>
            <CreateMissionWorker />
        </MockedProvider>
    );
};

const meta = {
    title: "CreateMission/Worker",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
